import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import './App.css';
import Homepage from './page/Homepage';
import Login from './components/Auth/Login';
import CheckAvailabilityTable from './page/Availibilty';
import SignupWithOtp from './components/Auth/Signup';
import AboutUsPage from './page/AboutUs';
import { fetchUserDetails } from './store/slice/features/authSlice';
import DestinationDetails from "./components/DestinationDetails";
import ScrollToTop from "./components/ScrollToTop";
import Cancellation from "./page/Cancellation";
import Tenders from "./page/Tenders";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "./components/Auth/ForgotPassword";
import SuccessPage from "./components/SuccessPage";
import FailurePage from "./components/FailurePage";
import NewHeader from "./components/NewHeader";
import Newfooter from "./components/Newfooter";
import HotelInvoice from "./components/Receipt/HotelInvoice";
import Loading from './components/Loading';
import AdvanceBookingForm from "./page/AdvanceBookingForm";
import Notice from "./page/Notice";
import SingleProduct from "./page/DestinationSection";
import GeneratePDFButton from "./components/GeneratePDFButton";
import Error404 from "./components/Error/Error404";
import Events from "./page/Events";
import UserProfile from "./components/UserProfile/UserProfile";
import GalleryPage from "./components/GalleryPage/GalleryPage";
import SectionPage from "./components/GallerySection/SectionPage";
import WebsiteTerms from "./page/WebsiteTerms";
import PrivacyPolicy from "./page/PrivacyPolicy";
import CancellationPolicy from "./page/CancellationPolicy";
import AllVideos from "./page/AllVideos";

const HotelDetails=React.lazy(()=>import('./page/HotelDetails'))
const AdvertorialList = React.lazy(() => import('./components/AdvertorialList'));
const AdvertorialDetails = React.lazy(() => import('./components/AdvertorialDetails'));
const TourDetails = React.lazy(() => import('./components/TourDetails'));
const Dashboard = React.lazy(() => import('./page/BookingHistory'));
const BookHotel = React.lazy(() => import('./page/BookHotel'));
const OrganizationalStructure = React.lazy(() => import('./page/OrganizationalStructure'));
const HotelList = React.lazy(() => import('./page/HotelList'));
const TourPackage = React.lazy(() => import('./components/TourPackage'));


const App = () => {
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.auth);
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    dispatch(fetchUserDetails());
  }, [dispatch]);

  return (
    <Router>
      <ScrollToTop />
      <Main destinations={destinations} setDestinations={setDestinations} />
    </Router>
  );
};

const Main = ({ destinations, setDestinations }) => {
  const location = useLocation();

  const isLoginPage = ["/signup", "/login", "/forgot-password"].includes(location.pathname);
  const hideHeaderFooter =
    isLoginPage ||
    location.pathname.startsWith("/booking-view") ||
    location.pathname.startsWith("/booking-Invoice") ||
    location.pathname.startsWith("/booking-history") ||
    // location.pathname.startsWith("/availibilty/book-hotel") ||
    location.pathname.startsWith("/booking-success") ||
    location.pathname.startsWith("/advertorial") ||
    location.pathname === "/booking-failed";

  return (
    <div className="App">
      <ToastContainer />

      {!hideHeaderFooter && <NewHeader />}

      <Routes>
        <Route path="/" element={<Homepage setDestinations={setDestinations} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignupWithOtp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/single-destination/:slug" element={<SingleProduct />} />
        <Route path="/About" element={<AboutUsPage />} />
        <Route path="/pdf-gallery" element={<GalleryPage />} />
        <Route path="/gallery-section/:sectionKey" element={<SectionPage />} />
        <Route path="/generatePdf" element={<GeneratePDFButton />} />
        <Route path="/events" element={<Events />} />
        <Route path="/all-videos" element={<AllVideos />} />
        <Route path="/organizational-structure"element={<OrganizationalStructure /> }/>

        <Route path="/hotel/:hotelID" element={
          <Suspense fallback={<Loading />}>
            <HotelDetails />
          </Suspense>
        } />
        <Route path="/allhotel/" element={
          <Suspense fallback={<Loading />}>
            <HotelList />
          </Suspense>
        } />
        <Route path="/availibilty" element={<CheckAvailabilityTable />} />
        <Route
          path="/availibilty/book-hotel/:hotelID"
          element={
            <PrivateRoute>
              <Suspense fallback={<Loading />}>
                <BookHotel />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route path="/booking-success/:orderId" element={<SuccessPage />} />
        <Route path="/booking-failed" element={<FailurePage />} />
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/notice" element={<Notice />} />
        <Route path="/advanceBooking" element={<AdvanceBookingForm />} />
        <Route path="/advertorial" element={
          <Suspense fallback={<Loading />}>
            <AdvertorialList />
          </Suspense>
        } />
        <Route path="/advertorial/:id" element={
          <Suspense fallback={<Loading />}>
            <AdvertorialDetails />
          </Suspense>
        } />
        <Route
          path="/booking-Invoice/:P_intBookingID"
          element={<HotelInvoice />}
        />
        <Route path="/tour-details/:id" element={
          <Suspense fallback={<Loading />}>
            <TourDetails />
          </Suspense>
        } />
        <Route
          path="/destination/:id"
          element={<DestinationDetails destinations={destinations} />}
        />
        <Route
          path="/booking-history"
          element={
            <PrivateRoute>
              <Suspense fallback={<Loading />}>
                <Dashboard />
              </Suspense>

            </PrivateRoute>
          }
        />
        <Route
          path="/cancel-booking/:bookingId"
          element={<PrivateRoute><Cancellation /></PrivateRoute>}
        />
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/tours" element={
          <Suspense fallback={<Loading />}>
            <TourPackage />
          </Suspense>
        } />
        <Route
          path="/my-account"
          element={
            <PrivateRoute>
              <Suspense fallback={<Loading />}>
                <UserProfile />
              </Suspense>
            </PrivateRoute>
          }
        />
   

        <Route path="*" element={<Error404 />} />
        <Route path="/terms-and-conditions" element={<WebsiteTerms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy/>} />
      </Routes>

      {!hideHeaderFooter && <Newfooter />}
    </div>
  );
};


export default App;